/**
 * `new Date('AAAA-MM-DD')` (string vinda direto de `<input type="date">`) é interpretado
 * pelo JS como meia-noite em UTC, não no fuso local — para quem está atrás de UTC (ex.
 * Brasil, UTC-3), isso vira "um dia antes" assim que formatado de volta com
 * `toLocaleDateString` (ou qualquer exibição em fuso local). Constrói a partir dos
 * componentes ano/mês/dia, que o construtor do Date sempre interpreta no fuso local —
 * fecha o ciclo salvar/exibir sem perder um dia.
 */
export function dataInputParaDate(valor: string): Date {
  const [ano, mes, dia] = valor.split('-').map(Number);
  return new Date(ano, mes - 1, dia);
}

/**
 * Padrão brasileiro do sistema pra datas em texto livre (ISO "AAAA-MM-DD" vindo de
 * `<input type="date">`, ou já "DD/MM/AAAA"/"DD-MM-AAAA" digitado por fora, ex. Forms do
 * SharePoint) — sempre normaliza pra "DD-MM-AAAA". Formatos não reconhecidos voltam sem
 * alteração (nunca corrompe um texto livre que não seja data).
 */
/** Timestamp do Firestore -> valor de `<input type="date">` ("AAAA-MM-DD") — inverso de
 * `dataInputParaDate`, usado pra pré-preencher formulários de edição. */
export function timestampParaDataInput(timestamp: { toDate: () => Date } | null | undefined): string {
  if (!timestamp) return '';
  return timestamp.toDate().toISOString().slice(0, 10);
}

export function paraDataBR(valor: string): string {
  const iso = valor.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (iso) return `${iso[3]}-${iso[2]}-${iso[1]}`;

  const brComSeparador = valor.match(/^(\d{2})[/-](\d{2})[/-](\d{4})$/);
  if (brComSeparador) return `${brComSeparador[1]}-${brComSeparador[2]}-${brComSeparador[3]}`;

  return valor;
}
